import request from '../utils/request'
import rootUrl from "../utils/api";
export function Login(data) {
    return request({
        url: rootUrl + `/login/login-by-code?code=${data.code}&token=${data.token}`,
        method: 'get',
    })
}

export function indexPagers(data) {
    return request({
        url: rootUrl + '/should-charge/query',
        method: 'post',
        data: data
    })
}

export function indeximportExcels(data) {
    return request({
        url: '/api/allocation-template/import-excels',
        method: 'post',
        data: data
    })
}
export function indexdownModel() {
    return request({
        url: rootUrl + '/should-charge/downloadChargeTemplate',
        method: 'get',
    })
}
export function validate() {
    return request({
        url: rootUrl + '/should-charge/validate',
        method: 'get',
    })
}
export function indexexportExcels(data) {
    return request({
        url: rootUrl + `/should-charge/export?begin=${data.begin}&end=${data.end}&chargeFrom=${data.chargeFrom}&chargeItem=${data.chargeItem}&empName=${data.empName}&empNo=${data.empNo}&idCard=${data.idCard}`,
        method: 'get',
    })
}

export function getRealCharge(data) {
    return request({
        url: rootUrl + '/real-charge/query',
        method: 'post',
        data: data
    })
}

export function getArg(data) {
    return request({
        url: rootUrl + '/para/query',
        method: 'post',
        data: data
    })
}


//获取参数管理
export function getchargeItem(data) {
    return request({
        url: rootUrl + '/para/query',
        method: 'post',
        data: data
    })

}

export function getMultipleCharge(data) {
    return request({
        url: rootUrl + '/multiple-charge/query',
        method: 'post',
        data: data
    })
}

export function getMultipleDetails(data) {
    return request({
        url: rootUrl + `/multiple-charge-detail-item/getByDetailId?id=${data}`,
        method: 'get',
    })
}

export function delMutipleDetails(data) {
    return request({
        url: rootUrl + `/multiple-charge-detail-item/delete?id=${data}`,
        method: 'delete',
    })
}

export function addMutipleDetails(data) {
    return request({
        url: rootUrl + `/multiple-charge-detail-item/add`,
        method: 'post',
        data: data
    })
}

export function delMultiple(data) {
    return request({
        url: rootUrl + `/multiple-charge/delete?id=${data}`,
        method: 'delete',
    })
}
export function addParams(data) {
    return request({
        url: rootUrl + `/para/add`,
        method: 'post',
        data: data
    })
}

export function delParams(data) {
    return request({
        url: rootUrl + `/para/delete?id=${data}`,
        method: 'delete',
    })
}

export function getByDept(data) {
    return request({
        url: rootUrl + `/charge-summary/get-report-by-year-dept`,
        method: 'post',
        data: data
    })
}

export function getByItem(data) {
    return request({
        url: rootUrl + `/charge-summary/get-report-by-year-item`,
        method: 'post',
        data: data
    })
}

export function loginOut() {
    return request({
        url: rootUrl + `/login/login-out`,
        method: 'get',
    })
}

// 黑名单管理 2021年12月02日

export function blackListChargeQuery(data){
	return request({
		url: rootUrl + `/blacklist-charge/query`,
		method:'post',
		data:data
	})
}
export function blackListQuery(data){
	return request({
		url:rootUrl + `/blacklist/query`,
		method:'post',
		data:data
	})
}
export function addBlackList(data){
	return request({
		url: rootUrl + `/blacklist/add`,
		method:'post',
		data:data
	})
}
export function deleteBlackList(data){
	return request({
		url: rootUrl + `/blacklist/delete?id=${data.id}`,
		method:'delete'
	})
}
export function blacklistExcel(){
	return request({
		url:rootUrl + `/blacklist/export`,
		method:'get',
		responseType:'blob'
	})
}
export function exportBlackList(data){
	return request({
		url:rootUrl + `/blacklist-charge/export?begin=${data.begin}&end=${data.end}&empName=${data.empName}&empNo=${data.empNo}&idCard=${data.idCard}`,
		method:'get',
		responseType:'blob'
	})
}
export function importBlackList(data){
	return request({
		url:rootUrl + `/blacklist-charge/upload`,
		method:'post',
		responseType:'blob'
	})
}